import { render, staticRenderFns } from "./AddWechatUser.vue?vue&type=template&id=5f62bdea&scoped=true"
import script from "./AddWechatUser.vue?vue&type=script&lang=js"
export * from "./AddWechatUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62bdea",
  null
  
)

export default component.exports